import { Box, Stack, Typography } from '@mui/material'
import { TaskV1TaskActionsServiceReassign } from 'c1gen/permissions'
import { C1Button } from 'c1ui'
import { C1Icon } from 'components/core/icons/C1Icon'
import { TaskPrimaryActionsButton } from 'components/core/task-list-v2/task-list-v2-components/styles'
import { TaskPrimaryActionsV2Variant } from 'components/core/task-list-v2/task-list-v2-components/TaskPrimaryActionsV2'
import { HasCapability } from 'components/no-ui/capability'
import { ReassignTaskDialogV2 } from 'components/pages/task/details/task-content-v2/common/ReassignTaskDialogV2'
import { canActOn } from 'components/pages/task/state'
import { TaskValue } from 'lib/actions/task'
import { useSimpleModal } from 'lib/modals'
import { TriangleAlert } from 'lucide-react'
import { TaskActionType } from 'pbts/c1/api/task/v1/task'
import { FC, useCallback } from 'react'
import { FormattedMessage } from 'react-intl'

export const SelfApprovalNotAllowedPrimaryAction: FC<{ task: TaskValue, variant: TaskPrimaryActionsV2Variant }> = ({ task, variant }) => {
    const { open } = useSimpleModal()

    const handleClick = useCallback((): void => {
        open(ReassignTaskDialogV2, { task })()
    }, [open, task])

    return (
        <Stack direction="row" spacing={1} alignItems="center">
            <C1Icon icon={TriangleAlert} sx={TaskPrimaryActionsButton.warningIcon} />
            <Typography>
                <FormattedMessage id="task_no_self_action" defaultMessage="No self approval" />
            </Typography>
            <Box>
                {canActOn(task, TaskActionType.REASSIGN) && (
                    <HasCapability permission={TaskV1TaskActionsServiceReassign}>
                        <C1Button variant={variant === 'contained' ? 'contained' : 'outlined'} onClick={handleClick}>
                            <FormattedMessage id="component_task_list_reassign_option_label" defaultMessage="Reassign" />
                        </C1Button>
                    </HasCapability>
                )}
            </Box>
        </Stack>
    )
}
